import { defineAsyncComponent } from 'vue'
export default {
  external: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/external.vue").then(m => m.default || m)),
  sidebar: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/sidebar.vue").then(m => m.default || m)),
  "terminal-redeem": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/terminal-redeem.vue").then(m => m.default || m)),
  "terminal-sell": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/terminal-sell.vue").then(m => m.default || m))
}